import { Player, Controls } from '@lottiefiles/react-lottie-player'
import { Typography, Box } from '@mui/material'
import CommonButton from 'components/commonButton/CommonButton';
import NoInternetAnimation from './NoInternetAnimation.json';
import "./NoInternetMessage.scss"

const NoInternetMessage = () => {
  const handleNetworkStatus = () => {
    window.location.reload();
  }

  return (
    <Box className="height100vh flexAlignCenter flexColumn">
    <Box className="flexColumn flexAlignCenter noInternetMessageContainer">
      <Player autoplay loop src={NoInternetAnimation} >
        <Controls
          visible={false}
          buttons={['play', 'repeat', 'frame', 'debug']}
        />
      </Player>
      <Box className="actionBtn">
      <Typography variant="head2" className="fw600 colorPrimary mb10 textCenter">
        No Internet Connection
      </Typography>
      <CommonButton
          onClick={handleNetworkStatus}
          name={'Try Again'}
          btnClass={'btnYellow btnMedium'}
        />
      </Box>    
    </Box>
    </Box>
  )
}

export default NoInternetMessage

